var subMenu = {
	$this: $( '.js-sub-menu' ),
	setHeight: function( $submenu ) {
		var submenuHeight = $submenu.children( 'ul' ).outerHeight( true );
		return submenuHeight;
	},
	openClose: function( $item ) {
		var $sub = $item.find( '.sub-sub-menu' );
		if ( $sub.hasClass( 'active' ) ) {
			$sub.removeClass( 'active' ).removeAttr( 'style' );
		} else {
			var newHeight = subMenu.setHeight( $sub );
			$sub.addClass( 'active' ).css( { 'height': newHeight } );
		}
	},
	init: function() {
		subMenu.$this.find('.arrow').on( 'click', function( e ) {
			e.preventDefault();
			subMenu.openClose( $( this ).parent( 'li' ) );
		} );
		subMenu.$this.children( 'ul' ).children( 'li.current_page_ancestor, li.current_page_item' ).each( function() {
			subMenu.openClose( $(this) );
		} );
	},
};
